<template>
    <div>
        <div class="dataTables_wrapper dt-bootstrap4">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <table class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(items, item, j) in creditItems" :key="j">
                                <td>{{j+1}}</td>
                                <td>{{item}}</td>
                                <td>{{formatPrice(items.topup)}}</td>
                                <td>{{formatPrice(items.redeem)}}</td>
                                <td>{{formatPrice(items.balance)}}</td>
                            </tr>
                            <tr>
                                <td colspan="2" class="border-top-bottom-2 text-right fw-700">{{$t('label.total')}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('topup'))}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('redeem'))}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('balance'))}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment'
import {setCreditSummaryItems} from './../../../../assets/js/dashboard/salonReport/salonReport'
import {handleSessionExpired, getOutletName} from './../../../../assets/js/dashboard/dashboard'
import {formatPrice, dateRange, reorderObject, setAYearArr, setYearArr}
from '@/assets/js/dashboard/utilities'
export default {
    name: "creditSummaryDate",
    data(){
        return{
            typeItems: ['topup', 'redeem'], creditItems: {}, 
            filterObj: {}
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#", thClass: 'thead-themed align-middle'},
                {key: "date", label: this.$i18n.t('table.header.date'), thClass: 'thead-themed align-middle'},
                {key: "topup", label: this.$i18n.t('salon_report.credit.top_up'), thClass: 'thead-themed align-middle'},
                {key: "redeem", label: this.$i18n.t('salon_report.credit.redeem'), thClass: 'thead-themed align-middle'},
                {key: "total", label: this.$i18n.t('table.header.balance'), thClass: 'thead-themed align-middle'},
            ]
        },
        exportField(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.date')).toUpperCase()] = "date"
            ret[(this.$i18n.t('salon_report.credit.top_up')).toUpperCase()] = "topup"
            ret[(this.$i18n.t('salon_report.credit.redeem')).toUpperCase()] = "redeem"
            ret[(this.$i18n.t('table.header.balance')).toUpperCase()] = "balance"
            return ret
        }
    },
    watch:{
        "$i18n.locale"(val){
            if(this.filterObj.summaryType == 'date'){
                this.setExportData(this.creditItems)
            }
        }
    },
    methods:{
        formatPrice(price){
            return formatPrice(price)
        },
        async setCreditSummary(filterObj){
            this.creditItems = [];
            this.filterObj = filterObj;
            var dateFilter = "?startCreateDate=" + moment(filterObj.date.startDate).unix() + "&endCreateDate=" + moment(filterObj.date.endDate).unix()
            var outletFilter = filterObj.outletID == "all" ? "" : "&outletID=" + filterObj.outletID;
            var searchFilter = filterObj.search == "" ? "" : "&search=" + filterObj.search 

            var summary = await this.getCreditSummary(dateFilter + outletFilter + searchFilter);
            const range = dateRange(moment(filterObj.date.startDate).toDate(), moment(filterObj.date.endDate).toDate());

            let $vm = this
            if(range.length < 365){
                // var rangeArr = range.map(date => convertDateToString(date))
                var rangeArr = range.map(date => moment(date).format($vm.$msg.CST.DATE_FORMAT))
                for(var i=0; i<summary.length; i++){
                    summary[i]["formatDate"] = moment.unix(summary[i].createDate).format(this.$msg.CST.DATE_FORMAT)
                }
                var group = _.groupBy(summary, "formatDate")
                for(var j=0; j<rangeArr.length; j++){
                    if(!(rangeArr[j] in group)){
                        group[rangeArr[j]] = []
                    }
                }
                var reordered = reorderObject(group)
                this.creditItems = setCreditSummaryItems(reordered)
            }else if(range.length == 366 || range.length == 365){
                var yearObj = setAYearArr(moment(filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT_YEAR))
                var index = 0
                for(var m in yearObj){
                    for(var l=0; l<summary.length; l++){
                        var month = moment.unix(summary[l].createDate).month();
                        if(month == index){
                            yearObj[m].push(summary[l])
                        }
                    }
                    index++;
                }
                this.creditItems = setCreditSummaryItems(yearObj)
            }else{
                var yearsObj = setYearArr(moment(filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT_YEAR), moment(filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT_YEAR))
                for(var y in yearsObj){
                    for(var x=0; x<summary.length; x++){
                        var year = moment.unix(summary[x].createDate).year();
                        if(year == y){
                            yearsObj[y].push(summary[x])
                        }
                    }
                }
                this.creditItems = setCreditSummaryItems(yearsObj)
            }
            this.setExportData(this.creditItems)

            var summaryItem = {}
            for(var k=0; k<this.typeItems.length; k++){
                summaryItem[this.typeItems[k]] = this.getTotal(this.typeItems[k])
            }
            var data = {
                date: this.dateRange,
                summary: summaryItem
            }
            this.$emit('setSummary', data)
        },
        async getCreditSummary(strFilter){
            let $vm = this;
            let QUERY_STRING = strFilter;
            const url =  this.$api.REPORT_CREDIT + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result;
        },
        getTotal(type){
            var total = 0;
            for(var key in this.creditItems){
                var item = this.creditItems[key]
                for(var itemType in item){
                    if(itemType == type){
                        total += parseFloat(item[itemType].toFixed(2))
                    }
                }
            }
            return total       
        },
        setExportData(data){
            var outlet = this.filterObj.outletID == "all" ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) : getOutletName(this.filterObj.outletID, JSON.parse(this.$store.state.outlets));
            
            var strDate = moment(this.filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(this.filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);
    
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_credit`) + "(" + this.$i18n.messages[this.$i18n.locale].tab.reportCreditTabs[0].text + ")" + " " + strDate
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_credit`), 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                this.$i18n.t('label.outlet') + ": " + outlet , 
                this.$i18n.t('salon_report.view') + this.$i18n.messages[this.$i18n.locale].tab.summary_type[1].text,
                " "];
            var exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            var exportData = []
            var i = 0;
            for(var key in data){
                exportData.push({
                    index: i+1,
                    date: key,
                    topup: data[key].topup,
                    redeem: data[key].redeem,
                    balance: data[key].balance,
                })
                i++;
            }
            exportData.push({
                index: "",
                date: this.$i18n.t('label.total'),
                topup: this.getTotal('topup'),
                redeem: this.getTotal('redeem'),
                balance: this.getTotal('balance'),
            })

            var exportObj = {
                data: exportData,
                fields: this.exportField,
                headers: exportHeaders,
                fileName: exportFileName
            }
            
            this.$emit('setExportData', exportObj)
        }
    },
}
</script>
<style scoped>
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
</style>